import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import useSEO from "@/lib/useSEO";
import { CheckCircle2, Award, Users, Sparkles } from "lucide-react";

export default function Kurumsal() {
  useSEO({
    title: "Kurumsal",
    description: "YK İnşaat Müteahhitlik hakkında: 25 yılı aşkın tecrübe, vizyon, misyon ve değerlerimiz.",
    path: "/kurumsal",
  });
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#0A0E1A]" data-testid="kurumsal-page">
      <section className="relative py-24 lg:py-32 border-b border-[#1F2937] overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="https://images.unsplash.com/photo-1767950470198-c9cd97f8ed87?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0E1A] to-[#0A0E1A]/60"></div>
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="section-label mb-6">Kurumsal</div>
          <h1 className="font-heading text-4xl lg:text-6xl text-white tracking-[0.05em] leading-tight max-w-3xl">
            25 Yıllık<br />
            <span className="text-[#C9A961]">Miras ve Vizyon</span>
          </h1>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="section-label mb-4">Hakkımızda</div>
            <h2 className="font-heading text-3xl lg:text-4xl text-white leading-tight tracking-[0.05em] mb-6">
              Değer Üretiyoruz,<br />
              <span className="text-[#C9A961]">Güven İnşa Ediyoruz</span>
            </h2>
            <p className="text-white/70 leading-relaxed mb-6">
              {stats?.about_text || "YK İnşaat Müteahhitlik olarak 25 yılı aşkın tecrübemizle Türkiye'nin dört bir yanında modern, güvenli ve estetik yaşam alanları inşa ediyoruz. Her projemizde kaliteyi, güveni ve zamanında teslimatı ön planda tutuyoruz."}
            </p>
            <ul className="space-y-3 mt-8">
              {["Kaliteli malzeme ve güçlü mühendislik", "Zamanında ve eksiksiz teslim", "Sürdürülebilir ve çevre dostu projeler", "Anahtar teslim çözümler"].map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/80">
                  <CheckCircle2 className="w-5 h-5 text-[#C9A961] mt-0.5 shrink-0" strokeWidth={1.5} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1757439402268-1da284675170?crop=entropy&cs=srgb&fm=jpg&w=900&q=80" alt="YK İnşaat" className="w-full aspect-[4/5] object-cover border border-[#C9A961]/30" />
            <div className="absolute -bottom-6 -right-6 bg-[#C9A961] text-[#0A0E1A] p-6 max-w-[220px]">
              <div className="font-heading text-4xl">25+</div>
              <div className="text-xs uppercase tracking-[0.2em] font-semibold mt-1">Yıllık Sektör Tecrübesi</div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 border-t border-[#1F2937]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="section-label mb-4 text-center">Vizyon & Misyon</div>
          <h2 className="font-heading text-3xl lg:text-4xl text-white text-center tracking-[0.05em] mb-16">Değerlerimiz</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Award, title: "Kalite", desc: "En yüksek yapı standartlarında, kalıcı ve güvenli projeler inşa ediyoruz." },
              { icon: Users, title: "Güven", desc: "Müşterilerimizle uzun soluklu ilişkiler kurmak temel ilkemizdir." },
              { icon: Sparkles, title: "İnovasyon", desc: "Modern mimari ve çağdaş yapı teknolojilerini projelerimize entegre ediyoruz." },
            ].map((v) => (
              <div key={v.title} className="yk-card p-10 text-center">
                <v.icon className="w-10 h-10 text-[#C9A961] mx-auto mb-6" strokeWidth={1.2} />
                <div className="font-heading text-xl text-white tracking-[0.15em] uppercase mb-4">{v.title}</div>
                <div className="text-white/60 text-sm leading-relaxed">{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
